export const getUuidFromUrl = (): string => {
  const { search } = window.location
  const query = new URLSearchParams(search)

  return query.get('uuid') || ''
}
